import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';

import { GetApp } from '@material-ui/icons';

const styles = theme => ({
    root: {
        fontSize: 11,
    },
});

const DownloadLink = props => {
    const { classes, href, color = 'textPrimary' } = props;
    return (
        <Link
            color={color}
            className={classes.root}
            underline="none"
            href={href}
        >
            <GetApp />
        </Link>
    );
};

export default withStyles(styles)(DownloadLink);
